// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2ZKwX","title":"Images45_title__3TwzP","images":"Images45_images__RVvnR"};